import "styled-components";

const summerTheme = {
  layout: {
    background: `   
    url("${process.env.PUBLIC_URL}/assets/images/background/sunflowers.png") no-repeat bottom center,
    radial-gradient(circle, #68aaa7, #487674)`,
  },
  header: {
    fontColor: "#ebd9cb",
    background: `linear-gradient(to right, transparent, rgba(52,	85,	83, 0.9), transparent)`,
  },
  footer: {
    fontColor: "#decebe",
  },
  switcher: {
    background: `linear-gradient(to right, transparent, rgba(222,200,185, 0.6), transparent)`,
    headerBackgroundColor: "#345553",
    bodyBackgroundColor: "#68aaa7",
    hoverColor: "#e1aca9",
    fontColor: "#ebe3d8",
    buttonFontColor: "#decebe",
  },
  calendar: {
    backgroundColors: {
      emptyCell: "#e1cdc0",
      mainCell: "#ffeddb",
      dayOfWeekCell: "#fbe9db",
    },
    fontColors: {
      main: "#9f8a6f",
      empty: "#c0bdb9",
      day: "#6f604d",
      sunday: "#d58985",
    },
  },
};

// #9aadb5

export default summerTheme;
